function storeImg(file, w = 400) {
  return `https://cdn.shopify.com/s/files/1/0705/6483/9574/files/${file}${file.includes("?") ? "&" : "?"}width=${w}`;
}

function item(id, title, amount, extras = {}) {
  const images = (extras.images || [extras.img]).filter(Boolean);
  const img = extras.img || images[0];
  const compare = extras.compare;
  const handle = extras.handle || id;
  return {
    id, title, amount, handle,
    url: `/products/${encodeURIComponent(handle)}`,
    price: `Rs.${amount.toLocaleString("en-PK")}`,
    compare: compare ? `Rs.${compare.toLocaleString("en-PK")}` : "",
    sale: extras.sale || (compare ? `-${Math.round((1 - amount / compare) * 100)}%` : ""),
    badge: extras.badge || "",
    img, images,
    desc: extras.desc || "",
    material: extras.material || "",
    pieces: extras.pieces || "",
    care: extras.care || "",
    sku: extras.sku || id,
    tag: extras.tag || extras.badge || "",
    blurb: extras.blurb || "",
    swatches: extras.swatches || null
  };
}

const catalog = {
  trending: [
    item("triffle-bowl", "Triffle Bowl", 4500, {
      handle: "crystal-triffle-bowl-19781",
      img: storeImg("IMG-9225.png?v=1772193887"),
      images: [storeImg("IMG-9225.png?v=1772193887", 800), storeImg("WhatsApp-Image-2025-03-19-at-4.36.34-PM_cf1f8b39-baa3-493b-a93f-c8456de1fc61.jpg?v=1768387611", 800)],
      desc: "A generous serving bowl for desserts and fruit, finished for everyday table use.",
      material: "Glass", pieces: "1 bowl", care: "Hand wash recommended", sku: "MC-TRB-01"
    }),
    item("3-tier-dish", "3 Tier Dish", 5400, {
      handle: "ceramic-3-tier-dish-3898", compare: 6000,
      img: storeImg("WhatsApp-Image-2025-03-19-at-4.36.40-PM_bee6285f-561a-4ecd-852a-4ccdb0e41094.jpg?v=1768387599"),
      images: [storeImg("WhatsApp-Image-2025-03-19-at-4.36.40-PM_bee6285f-561a-4ecd-852a-4ccdb0e41094.jpg?v=1768387599", 800), storeImg("IMG-9225.png?v=1772193887", 800)],
      desc: "A three-tier stand for cakes, sweets and afternoon service.",
      material: "Metal and ceramic", pieces: "3 tiers", care: "Wipe clean, dry immediately", sku: "MC-3TD-02"
    }),
    item("icecream-set", "Icecream Set", 6570, {
      handle: "ceramic-icecream-set-4003", compare: 7300,
      img: storeImg("WhatsApp-Image-2025-03-20-at-3.02.24-PM_813576a4-aa2d-45cb-8e79-60dc9590e5ad.jpg?v=1768387696"),
      images: [storeImg("WhatsApp-Image-2025-03-20-at-3.02.24-PM_813576a4-aa2d-45cb-8e79-60dc9590e5ad.jpg?v=1768387696", 800), storeImg("WhatsApp-Image-2025-03-19-at-4.36.34-PM_cf1f8b39-baa3-493b-a93f-c8456de1fc61.jpg?v=1768387611", 800)],
      desc: "A complete ice-cream service set with bowls and spoons for sharing.",
      material: "Ceramic", pieces: "6 bowls + spoons", care: "Dishwasher safe", sku: "MC-ICS-03"
    }),
    item("6-cup-saucer", "6 cup & saucer", 4140, {
      handle: "ceramic-6-cups-and-6-saucers-with-stand-3931", compare: 4600, badge: "New",
      img: storeImg("WhatsApp-Image-2025-03-19-at-3.09.05-PM-32_875d3f8b-9a06-4042-b26d-efaa03983765.jpg?v=1768387556"),
      images: [storeImg("WhatsApp-Image-2025-03-19-at-3.09.05-PM-32_875d3f8b-9a06-4042-b26d-efaa03983765.jpg?v=1768387556", 800), storeImg("IMG-9225.png?v=1772193887", 800)],
      desc: "A six-piece cup and saucer set for tea and coffee service.",
      material: "Fine ceramic", pieces: "6 cups + 6 saucers", care: "Dishwasher safe", sku: "MC-CS6-04"
    }),
    item("stoneware-soup-bowl", "Stoneware Soup Bowl", 1170, {
      handle: "stoneware-soup-bowl-3719", compare: 1300,
      img: storeImg("WhatsApp-Image-2025-03-19-at-4.36.34-PM_cf1f8b39-baa3-493b-a93f-c8456de1fc61.jpg?v=1768387611"),
      images: [storeImg("WhatsApp-Image-2025-03-19-at-4.36.34-PM_cf1f8b39-baa3-493b-a93f-c8456de1fc61.jpg?v=1768387611", 800), storeImg("WhatsApp-Image-2025-03-19-at-4.36.40-PM_bee6285f-561a-4ecd-852a-4ccdb0e41094.jpg?v=1768387599", 800)],
      desc: "A durable stoneware bowl for soups, breakfast and everyday serving.",
      material: "Stoneware", pieces: "1 bowl", care: "Microwave and dishwasher safe", sku: "MC-SSB-05"
    })
  ],
  dinner: [
    item("imperial-dinner", "Imperial Dinner Set", 190000, {
      handle: "imperial-dinner-set-8-serving-thailand-1319", compare: 195000,
      img: storeImg("IMG_6995.jpg?v=1768386987"),
      images: [storeImg("IMG_6995.jpg?v=1768386987", 800), storeImg("WhatsApp-Image-2025-03-20-at-3.02.29-PM-1.jpg?v=1768387663", 800)],
      desc: "A 61-piece Thailand bone china service for eight, ready for formal entertaining.",
      material: "Bone china", pieces: "61 pieces / 8 servings", care: "Hand wash recommended"
    }),
    item("stoneware-dinner", "Stoneware Dinner Set", 135000, {
      handle: "stoneware-dinner-set-12-serving-85-pcs-19259",
      img: storeImg("WhatsApp-Image-2025-08-08-at-8.45.52-AM_78ad184a-063a-457b-bcec-d487d8ace8ab.jpg?v=1768390360"),
      images: [storeImg("WhatsApp-Image-2025-08-08-at-8.45.52-AM_78ad184a-063a-457b-bcec-d487d8ace8ab.jpg?v=1768390360", 800)],
      desc: "An 85-piece stoneware set for twelve with a calm modern finish.",
      material: "Stoneware", pieces: "85 pieces / 12 servings", care: "Microwave and dishwasher safe"
    }),
    item("dinner-8-servings", "Dinner Set 8 Servings", 43000, {
      handle: "dinner-set-karosa-8-servings-3550", compare: 48000,
      img: storeImg("WhatsApp-Image-2025-03-20-at-3.02.29-PM-1.jpg?v=1768387663"),
      images: [storeImg("WhatsApp-Image-2025-03-20-at-3.02.29-PM-1.jpg?v=1768387663", 800), storeImg("IMG_6995.jpg?v=1768386987", 800)],
      desc: "A complete 61-piece bone china dinner service for eight guests.",
      material: "Bone china", pieces: "61 pieces / 8 servings", care: "Dishwasher safe"
    }),
    item("noritake-dinner", "Noritake Japanese Set", 75000, {
      handle: "noritake-japanese-8-serving-61pc-1974", compare: 85000,
      img: storeImg("WhatsApp-Image-2025-03-15-at-1.21.04-PM.jpg?v=1768387145"),
      images: [storeImg("WhatsApp-Image-2025-03-15-at-1.21.04-PM.jpg?v=1768387145", 800)],
      desc: "Super bone china from Noritake, trimmed for weddings and festive tables.",
      material: "Super bone china", pieces: "61 pieces / 8 servings", care: "Dishwasher safe", badge: "Luxury"
    }),
    item("onemore-dinner", "One More Dinner Set", 105000, {
      handle: "one-more-dinner-set-8-servings-23070",
      img: storeImg("WhatsApp-Image-2025-10-21-at-2.17.20-AM-1_319175d5-c8e8-4397-a0ce-b80c8a687606.jpg?v=1768390953"),
      images: [storeImg("WhatsApp-Image-2025-10-21-at-2.17.20-AM-1_319175d5-c8e8-4397-a0ce-b80c8a687606.jpg?v=1768390953", 800), storeImg("WhatsApp-Image-2025-10-21-at-2.17.18-AM-2_0398c4cf-5c0b-4d6b-b4db-a24de96dea05.jpg?v=1768390950", 800)],
      desc: "A high-quality 61-piece superbone service with kettle, milk pot and sugar pot.",
      material: "Superbone", pieces: "61 pieces / 8 servings", care: "Hand wash recommended"
    })
  ],
  decor: [
    item("candle-stand-gold", "Gold Candle Stand", 4500, {
      handle: "metal-golden-candle-stand-3228", compare: 5000,
      img: storeImg("WhatsApp-Image-2025-05-01-at-12.58.06-PM-3_7012cf2f-f81b-4db9-9e4b-a457a8b7ee01.jpg?v=1768389081"),
      images: [storeImg("WhatsApp-Image-2025-05-01-at-12.58.06-PM-3_7012cf2f-f81b-4db9-9e4b-a457a8b7ee01.jpg?v=1768389081", 800), storeImg("WhatsApp-Image-2025-05-01-at-12.58.12-PM_ec91c6fa-ec57-4482-8a91-aeded073f9c1.jpg?v=1768389070", 800)],
      desc: "A sculpted stand that holds the candle securely and warms the table.",
      material: "Metal", pieces: "1 stand", care: "Wipe clean"
    }),
    item("candle-stand-classic", "Classic Candle Stand", 4300, {
      handle: "crystal-candle-stand-1482", compare: 4800,
      img: storeImg("WhatsApp-Image-2025-05-01-at-12.58.12-PM_ec91c6fa-ec57-4482-8a91-aeded073f9c1.jpg?v=1768389070"),
      images: [storeImg("WhatsApp-Image-2025-05-01-at-12.58.12-PM_ec91c6fa-ec57-4482-8a91-aeded073f9c1.jpg?v=1768389070", 800)],
      desc: "A stable, charming piece for dining tables and evening corners.",
      material: "Metal", pieces: "1 stand", care: "Wipe clean"
    }),
    item("glass-candle-stand", "Glass Candle Stand", 1850, {
      handle: "glass-candle-stand-22496", badge: "New",
      img: storeImg("WhatsApp-Image-2025-10-09-at-5.34.50-AM_1f3e8f1b-219b-4ebe-ae8a-69201cb805f8.jpg?v=1768390868"),
      images: [storeImg("WhatsApp-Image-2025-10-09-at-5.34.50-AM_1f3e8f1b-219b-4ebe-ae8a-69201cb805f8.jpg?v=1768390868", 800)],
      desc: "Premium glass that catches candlelight for a refined evening glow.",
      material: "Glass", pieces: "1 stand", care: "Hand wash"
    }),
    item("crystal-candle-stand", "Crystal Candle Stand", 3200, {
      handle: "crystal-candle-stand-medium-15589", compare: 3800,
      img: storeImg("WhatsApp-Image-2025-05-07-at-7.46.01-PM-1_6fa67e58-d157-4f4f-a25d-cda0680023f9.jpg?v=1768389623"),
      images: [storeImg("WhatsApp-Image-2025-05-07-at-7.46.01-PM-1_6fa67e58-d157-4f4f-a25d-cda0680023f9.jpg?v=1768389623", 800)],
      desc: "A medium crystal stand for gifting or a dressed dining table.",
      material: "Crystal", pieces: "1 stand", care: "Hand wash"
    }),
    item("metal-candle-set", "Metal Candle Set", 6450, {
      handle: "metal-golden-candle-stand-3228", compare: 7150,
      img: storeImg("WhatsApp-Image-2025-05-04-at-3.11.20-PM.jpg?v=1768389359"),
      images: [storeImg("WhatsApp-Image-2025-05-04-at-3.11.20-PM.jpg?v=1768389359", 800), storeImg("WhatsApp-Image-2025-05-04-at-3.10.30-PM_ad484c18-dcea-4206-9dfd-2217dc75b1f2.jpg?v=1768389358", 800)],
      desc: "A three-piece metal set for a complete tablescape arrangement.",
      material: "Metal", pieces: "3 stands", care: "Wipe clean"
    })
  ],
  bestsellers: [
    item("bs-imperial", "Imperial Dinner Set", 190000, {
      handle: "imperial-dinner-set-8-serving-thailand-1319", compare: 195000,
      tag: "Customer favorite",
      blurb: "Bone china for eight - a formal table statement piece.",
      img: storeImg("IMG_6995.jpg?v=1768386987"),
      images: [storeImg("IMG_6995.jpg?v=1768386987", 800)],
      desc: "Thailand bone china for eight - a formal table statement.",
      material: "Bone china", pieces: "61 pieces / 8 servings", care: "Hand wash recommended",
      swatches: ["#e8dfd2", "#c9b8a0", "#8b7355"]
    }),
    item("bs-gold-candle", "Gold Candle Stand", 4500, {
      handle: "metal-golden-candle-stand-3228", compare: 5000,
      tag: "Promotion",
      blurb: "Sculpted metal that warms the evening tablescape.",
      img: storeImg("WhatsApp-Image-2025-05-01-at-12.58.06-PM-3_7012cf2f-f81b-4db9-9e4b-a457a8b7ee01.jpg?v=1768389081"),
      images: [storeImg("WhatsApp-Image-2025-05-01-at-12.58.06-PM-3_7012cf2f-f81b-4db9-9e4b-a457a8b7ee01.jpg?v=1768389081", 800)],
      desc: "A sculpted stand that holds the candle securely and warms the table.",
      material: "Metal", pieces: "1 stand", care: "Wipe clean",
      swatches: ["#d4af37", "#c0c0c0", "#8b6914"]
    }),
    item("bs-glass-candle", "Glass Candle Stand", 1850, {
      handle: "glass-candle-stand-22496",
      tag: "New",
      blurb: "Clear glass that catches candlelight after dark.",
      img: storeImg("WhatsApp-Image-2025-10-09-at-5.34.50-AM_1f3e8f1b-219b-4ebe-ae8a-69201cb805f8.jpg?v=1768390868"),
      images: [storeImg("WhatsApp-Image-2025-10-09-at-5.34.50-AM_1f3e8f1b-219b-4ebe-ae8a-69201cb805f8.jpg?v=1768390868", 800)],
      desc: "Premium glass that catches candlelight for a refined evening glow.",
      material: "Glass", pieces: "1 stand", care: "Hand wash",
      swatches: ["#e8eef0", "#d4c4a8", "#6b7c78"]
    }),
    item("bs-royal-albert", "Royal Albert Tea Set", 28000, {
      handle: "32-piece-royal-albert-tea-set-deluxe-edition-18159",
      tag: "Deluxe",
      blurb: "Fine china for elevated afternoon tea moments.",
      img: storeImg("WhatsApp-Image-2025-05-27-at-3.07.44-PM_02b4ffaa-8231-40e3-be70-f0c639282653.jpg?v=1768390187"),
      images: [storeImg("WhatsApp-Image-2025-05-27-at-3.07.44-PM_02b4ffaa-8231-40e3-be70-f0c639282653.jpg?v=1768390187", 800)],
      desc: "32-piece Royal Albert deluxe tea service for elevated afternoons.",
      material: "Fine china", pieces: "32 pieces", care: "Hand wash recommended",
      swatches: ["#f5e6e8", "#c4a484", "#2c5545"]
    }),
    item("bs-noritake", "Noritake Japanese Set", 75000, {
      handle: "noritake-japanese-8-serving-61pc-1974", compare: 85000,
      tag: "Luxury",
      blurb: "Super bone china trimmed for weddings and feasts.",
      img: storeImg("WhatsApp-Image-2025-03-15-at-1.21.04-PM.jpg?v=1768387145"),
      images: [storeImg("WhatsApp-Image-2025-03-15-at-1.21.04-PM.jpg?v=1768387145", 800)],
      desc: "Super bone china trimmed for weddings and festive dinners.",
      material: "Super bone china", pieces: "61 pieces / 8 servings", care: "Dishwasher safe",
      swatches: ["#f7f3ea", "#e0d5c4", "#9a8b7a"]
    }),
    item("bs-turkish-platter", "Turkish Deep Platter", 6300, {
      handle: "ceramic-turkish-deep-platter-with-stand-4050",
      tag: "Promotion",
      blurb: "Signature platter with stand for serving and display.",
      img: storeImg("WhatsApp-Image-2025-03-20-at-4.55.05-PM.jpg?v=1768387709"),
      images: [storeImg("WhatsApp-Image-2025-03-20-at-4.55.05-PM.jpg?v=1768387709", 800)],
      desc: "Signature Turkish platter with stand for serving and display.",
      material: "Ceramic & metal", pieces: "Platter + stand", care: "Hand wash",
      swatches: ["#c9a86c", "#5c4033", "#e8dcc8"]
    }),
    item("bs-tea-24", "24 pcs Tea Set", 36000, {
      handle: "24-pcs-tea-set-22279",
      tag: "New",
      blurb: "A complete tea service with a polished premium finish.",
      img: storeImg("WhatsApp-Image-2025-10-08-at-2.15.21-AM.jpg?v=1768390821"),
      images: [storeImg("WhatsApp-Image-2025-10-08-at-2.15.21-AM.jpg?v=1768390821", 800)],
      desc: "A complete 24-piece tea set with a polished premium finish.",
      material: "Fine ceramic", pieces: "24 pieces", care: "Dishwasher safe",
      swatches: ["#ede4d4", "#a67c52", "#3d4f4a"]
    }),
    item("bs-crystal-candle", "Crystal Candle Stand", 3200, {
      handle: "crystal-candle-stand-medium-15589", compare: 3800,
      tag: "Customer favorite",
      blurb: "Medium crystal stand for gifting or dressed dining.",
      img: storeImg("WhatsApp-Image-2025-05-07-at-7.46.01-PM-1_6fa67e58-d157-4f4f-a25d-cda0680023f9.jpg?v=1768389623"),
      images: [storeImg("WhatsApp-Image-2025-05-07-at-7.46.01-PM-1_6fa67e58-d157-4f4f-a25d-cda0680023f9.jpg?v=1768389623", 800)],
      desc: "A medium crystal stand for gifting or a dressed dining table.",
      material: "Crystal", pieces: "1 stand", care: "Hand wash",
      swatches: ["#eef2f4", "#b8c4c8", "#7a8a8e"]
    })
  ],
  bags: [
    item("rimova-luggage-bag-3pcs", "Rimova Luggage Bag 3pcs", 35000, {
      handle: "rimova-luggage-bag-3pcs",
      img: storeImg("WhatsAppImage2026-04-02at4.11.18PM.jpg?v=1775174169"),
      images: [storeImg("WhatsAppImage2026-04-02at4.11.18PM.jpg?v=1775174169", 800)],
      desc: "A 3-piece hard-shell luggage set in black with smooth 360° wheels.",
      material: "Hard shell", pieces: "Large, medium & small", care: "Wipe clean", badge: "Best seller"
    }),
    item("flystar-luggage-bag-3pcs", "Flystar Luggage Bag 3pcs", 35000, {
      img: storeImg("WhatsAppImage2026-04-02at4.11.18PM_1.jpg?v=1775174051"),
      images: [storeImg("WhatsAppImage2026-04-02at4.11.18PM_1.jpg?v=1775174051", 800)],
      desc: "A beige-pink 3-piece luggage set with rotating wheels for easy travel.",
      material: "Hard shell", pieces: "Large, medium & small", care: "Wipe clean"
    }),
    item("rimova-suit-case-3pcs", "Rimova Suit Case 3pcs", 35000, {
      img: storeImg("WhatsAppImage2026-04-02at4.11.19PM.jpg?v=1775173969"),
      images: [storeImg("WhatsAppImage2026-04-02at4.11.19PM.jpg?v=1775173969", 800)],
      desc: "A grey Rimova 3-piece suit case set for everyday and long-haul trips.",
      material: "Hard shell", pieces: "Large, medium & small", care: "Wipe clean"
    }),
    item("flystar-suit-case-3pcs", "Flystar Suit Case 3pcs", 50000, {
      img: storeImg("WhatsAppImage2026-04-02at4.11.19PM_1.jpg?v=1775173904"),
      images: [storeImg("WhatsAppImage2026-04-02at4.11.19PM_1.jpg?v=1775173904", 800)],
      desc: "A peach Flystar 3-piece suit case set with smooth 360° wheels.",
      material: "Hard shell", pieces: "Large, medium & small", care: "Wipe clean"
    }),
    item("verage-luggage-bag-3pcs", "Verage Luggage Bag 3pcs", 60000, {
      img: storeImg("WhatsAppImage2026-04-02at4.11.20PM.jpg?v=1775173837"),
      images: [storeImg("WhatsAppImage2026-04-02at4.11.20PM.jpg?v=1775173837", 800)],
      desc: "A premium Verage 3-piece luggage set finished for frequent travellers.",
      material: "Hard shell", pieces: "Large, medium & small", care: "Wipe clean", badge: "Premium"
    }),
    item("swiss-traveler-3pcs-set", "Swiss Traveler 3pcs Set", 50000, {
      img: storeImg("WhatsAppImage2026-04-02at4.11.20PM_1.jpg?v=1775173767"),
      images: [storeImg("WhatsAppImage2026-04-02at4.11.20PM_1.jpg?v=1775173767", 800)],
      desc: "A green Swiss Traveler 3-piece set built for smooth airport runs.",
      material: "Hard shell", pieces: "Large, medium & small", care: "Wipe clean"
    })
  ],
  premiumCrockery: [
    item("imperial-dinner-trend", "Imperial Dinner Set", 190000, {
      compare: 195000, badge: "Premium",
      img: storeImg("IMG_6995.jpg?v=1768386987"),
      images: [storeImg("IMG_6995.jpg?v=1768386987", 800)],
      desc: "Thailand bone china for eight - a formal table statement.",
      material: "Bone china", pieces: "61 pieces / 8 servings", care: "Hand wash recommended"
    }),
    item("noritake-dinner-trend", "Noritake Japanese Set", 75000, {
      compare: 85000, badge: "Luxury",
      img: storeImg("WhatsApp-Image-2025-03-15-at-1.21.04-PM.jpg?v=1768387145"),
      images: [storeImg("WhatsApp-Image-2025-03-15-at-1.21.04-PM.jpg?v=1768387145", 800)],
      desc: "Super bone china trimmed for weddings and festive dinners.",
      material: "Super bone china", pieces: "61 pieces / 8 servings", care: "Dishwasher safe"
    }),
    item("onemore-dinner-trend", "One More Dinner Set", 105000, {
      badge: "Premium",
      img: storeImg("WhatsApp-Image-2025-10-21-at-2.17.20-AM-1_319175d5-c8e8-4397-a0ce-b80c8a687606.jpg?v=1768390953"),
      images: [storeImg("WhatsApp-Image-2025-10-21-at-2.17.20-AM-1_319175d5-c8e8-4397-a0ce-b80c8a687606.jpg?v=1768390953", 800)],
      desc: "61-piece superbone service with kettle, milk pot and sugar pot.",
      material: "Superbone", pieces: "61 pieces / 8 servings", care: "Hand wash recommended"
    }),
    item("royal-albert-tea-trend", "Royal Albert Tea Set", 28000, {
      badge: "Deluxe",
      img: storeImg("WhatsApp-Image-2025-05-27-at-3.07.44-PM_02b4ffaa-8231-40e3-be70-f0c639282653.jpg?v=1768390187"),
      images: [storeImg("WhatsApp-Image-2025-05-27-at-3.07.44-PM_02b4ffaa-8231-40e3-be70-f0c639282653.jpg?v=1768390187", 800)],
      desc: "32-piece Royal Albert deluxe tea service for elevated afternoons.",
      material: "Fine china", pieces: "32 pieces", care: "Hand wash recommended"
    }),
    item("tea-set-24-trend", "24 pcs Tea Set", 36000, {
      badge: "New",
      img: storeImg("WhatsApp-Image-2025-10-08-at-2.15.21-AM.jpg?v=1768390821"),
      images: [storeImg("WhatsApp-Image-2025-10-08-at-2.15.21-AM.jpg?v=1768390821", 800)],
      desc: "A complete 24-piece tea set with a polished premium finish.",
      material: "Fine ceramic", pieces: "24 pieces", care: "Dishwasher safe"
    }),
    item("stoneware-dinner-trend", "Stoneware Dinner Set", 135000, {
      badge: "Premium",
      img: storeImg("WhatsApp-Image-2025-08-08-at-8.45.52-AM_78ad184a-063a-457b-bcec-d487d8ace8ab.jpg?v=1768390360"),
      images: [storeImg("WhatsApp-Image-2025-08-08-at-8.45.52-AM_78ad184a-063a-457b-bcec-d487d8ace8ab.jpg?v=1768390360", 800)],
      desc: "85-piece stoneware for twelve with a calm modern finish.",
      material: "Stoneware", pieces: "85 pieces / 12 servings", care: "Microwave and dishwasher safe"
    }),
    item("turkish-platter-trend", "Turkish Deep Platter", 6300, {
      img: storeImg("WhatsApp-Image-2025-03-20-at-4.55.05-PM.jpg?v=1768387709"),
      images: [storeImg("WhatsApp-Image-2025-03-20-at-4.55.05-PM.jpg?v=1768387709", 800)],
      desc: "Signature Turkish platter with stand for serving and display.",
      material: "Ceramic & metal", pieces: "Platter + stand", care: "Hand wash"
    }),
    item("turkish-cake-dish-trend", "Turkish Cake Dish", 4800, {
      img: storeImg("WhatsApp-Image-2025-03-21-at-2.05.29-AM-1.jpg?v=1768387726"),
      images: [storeImg("WhatsApp-Image-2025-03-21-at-2.05.29-AM-1.jpg?v=1768387726", 800)],
      desc: "Ornate Turkish cake dish for desserts and festive tables.",
      material: "Ceramic", pieces: "1 dish", care: "Hand wash"
    })
  ],
  lamps: [
    item("turkish-lamps-pair-1", "Turkish Lamps Pair", 25000, {
      badge: "Bestseller",
      img: storeImg("WhatsAppImage2026-04-16at2.38.16PM_6.jpg?v=1776378224"),
      images: [storeImg("WhatsAppImage2026-04-16at2.38.16PM_6.jpg?v=1776378224", 800)],
      desc: "Signature Turkish glass and metal lamps - ideal for gifting.",
      material: "Glass & metal", pieces: "Pair", care: "Dust with dry cloth"
    }),
    item("crystal-lamp-pair", "Crystal Lamp Pair", 25000, {
      badge: "Premium",
      img: storeImg("WhatsAppImage2026-04-16at2.38.15PM_9.jpg?v=1776377335"),
      images: [storeImg("WhatsAppImage2026-04-16at2.38.15PM_9.jpg?v=1776377335", 800)],
      desc: "Crystal pair that catches light beautifully on side tables.",
      material: "Crystal", pieces: "Pair", care: "Wipe gently"
    }),
    item("metal-lamps-pair-2", "Metal Lamps Pair", 15000, {
      img: storeImg("WhatsAppImage2026-04-16at2.38.15PM_6.jpg?v=1776376856"),
      images: [storeImg("WhatsAppImage2026-04-16at2.38.15PM_6.jpg?v=1776376856", 800)],
      desc: "Sculpted metal lamps for living rooms and dining corners.",
      material: "Metal", pieces: "Pair", care: "Wipe clean"
    }),
    item("stylish-lamps-pair-4", "Stylish Lamps Pair", 22000, {
      badge: "New",
      img: storeImg("WhatsAppImage2026-04-16at2.38.16PM_4.jpg?v=1776378085"),
      images: [storeImg("WhatsAppImage2026-04-16at2.38.16PM_4.jpg?v=1776378085", 800)],
      desc: "Contemporary lamp pair finished for modern homes.",
      material: "Mixed materials", pieces: "Pair", care: "Dust regularly"
    }),
    item("brass-lamps-shade", "Brass Lamps with Shade", 83500, {
      badge: "Luxury",
      img: storeImg("WhatsApp-Image-2025-03-17-at-9.50.01-AM-1.jpg?v=1768387272"),
      images: [storeImg("WhatsApp-Image-2025-03-17-at-9.50.01-AM-1.jpg?v=1768387272", 800)],
      desc: "Elegant brass lamps with shade for a warm, premium glow.",
      material: "Brass & fabric shade", pieces: "Pair", care: "Wipe brass dry"
    }),
    item("glass-lamps-shade", "Stylish Glass Lamps", 10200, {
      img: storeImg("WhatsApp-Image-2025-04-30-at-4.18.06-PM-2.jpg?v=1768388990"),
      images: [storeImg("WhatsApp-Image-2025-04-30-at-4.18.06-PM-2.jpg?v=1768388990", 800)],
      desc: "Glass lamp pair with shade - soft light for dining ambience.",
      material: "Glass & shade", pieces: "Pair", care: "Hand wipe glass"
    }),
    item("crystal-lamp-shade", "Crystal Lamp with Shade", 10200, {
      img: storeImg("WhatsApp-Image-2025-04-30-at-4.18.16-PM-2.jpg?v=1768389061"),
      images: [storeImg("WhatsApp-Image-2025-04-30-at-4.18.16-PM-2.jpg?v=1768389061", 800)],
      desc: "Crystal lamp pair with shade for bedside or console styling.",
      material: "Crystal & shade", pieces: "Pair", care: "Gentle wipe"
    }),
    item("turkish-lamp-shade", "Turkish Lamp with Shade", 12750, {
      img: storeImg("WhatsApp-Image-2025-04-30-at-4.18.17-PM.jpg?v=1768389061"),
      images: [storeImg("WhatsApp-Image-2025-04-30-at-4.18.17-PM.jpg?v=1768389061", 800)],
      desc: "Turkish-inspired lamp pair with shade for cozy corners.",
      material: "Glass, metal & shade", pieces: "Pair", care: "Dust with soft cloth"
    })
  ]
};

const products = Object.values(catalog).flat();

const iconHeart = `<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M8 14s-5-3.1-5-6.5A2.8 2.8 0 018 5.3a2.8 2.8 0 015 2.2C13 10.9 8 14 8 14z"/></svg>`;
const iconCmp = `<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.5 4.5 3.5 7.5 6.5 10.5"/><path d="M3.5 7.5h7"/><path d="M13.5 15.5 16.5 12.5 13.5 9.5"/><path d="M16.5 12.5h-7"/></svg>`;
const iconBook = `<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5.5h10.5l-1.1 7.2H4.2L3 5.5z"/><path d="M5.5 5.5V4.4a2.5 2.5 0 015 0v1.1"/><circle cx="6.2" cy="14.2" r="0.9"/><circle cx="11.3" cy="14.2" r="0.9"/></svg>`;

function productCard(p) {
  const href = p.url || `/products/${encodeURIComponent(p.handle || p.id)}`;
  return `
  <article class="product" data-id="${p.id}" data-handle="${p.handle || p.id}">
    ${p.sale ? `<span class="badge sale">${p.sale}</span>` : ""}
    ${p.badge ? `<span class="badge">${p.badge}</span>` : ""}
    <div class="product__img">
      <a class="product__link" href="${href}" aria-label="View ${p.title}">
        <img src="${p.img}" alt="${p.title}" loading="lazy" decoding="async" width="400" height="400">
      </a>
      <div class="product__tools">
        <button type="button" class="wish" data-act="wish" aria-label="Add to wishlist" data-tip="Wishlist">${iconHeart}</button>
        <button type="button" data-act="compare" aria-label="Compare products" data-tip="Compare">${iconCmp}</button>
        <button type="button" data-act="book" aria-label="Order now" data-tip="Order now">${iconBook}</button>
      </div>
    </div>
    <div class="product__meta">
      <div class="product__info">
        <h3><a href="${href}">${p.title}</a></h3>
        <div class="price">${p.compare ? `<span class="old">${p.compare}</span>` : ""}<span class="${p.compare ? "sale-price" : ""}">${p.price}</span></div>
        <div class="stars">★★★★★</div>
      </div>
      <div class="product__buy">
        <button type="button" class="add" data-act="cart">Add to cart</button>
        <button type="button" class="book" data-act="book">Order now</button>
      </div>
    </div>
  </article>`;
}

function bestsellerCard(p) {
  const tag = p.tag || p.badge || "";
  const text = p.blurb || p.desc || p.title;
  const href = p.url || `/products/${encodeURIComponent(p.handle || p.id)}`;
  return `
  <article class="bs-card product" data-id="${p.id}" data-handle="${p.handle || p.id}">
    <div class="bs-card__media">
      ${tag ? `<span class="bs-card__tag">${tag}</span>` : ""}
      <a class="bs-card__stage" href="${href}" aria-label="View ${p.title}">
        <img src="${p.img}" alt="${p.title}" loading="lazy" decoding="async" width="480" height="480">
      </a>
    </div>
    <div class="bs-card__body">
      <h3 class="bs-card__title"><a href="${href}">${text}</a></h3>
      <div class="bs-card__foot">
        <div class="bs-card__price">
          ${p.compare ? `<span class="bs-card__was">${p.compare}</span>` : ""}
          <span class="bs-card__now">${p.price}</span>
        </div>
        <button type="button" class="bs-card__cart" data-act="cart" aria-label="Add ${p.title} to cart">+ Cart</button>
      </div>
    </div>
  </article>`;
}

function moneyFromCents(cents) {
  const n = Number(cents || 0) / 100;
  return "Rs." + Math.round(n).toLocaleString("en-PK");
}

function mapCollectionProduct(p) {
  if (!p) return null;
  const img =
    (p.images && p.images[0]) ||
    (p.featured_image && (p.featured_image.src || p.featured_image)) ||
    "";
  const compare = p.compare_at_price && p.compare_at_price > p.price ? moneyFromCents(p.compare_at_price) : "";
  return {
    id: String(p.handle || p.id),
    handle: p.handle,
    title: p.title,
    price: moneyFromCents(p.price),
    compare: compare,
    img: img,
    url: "/products/" + encodeURIComponent(p.handle || "")
  };
}

async function fetchCollectionProducts(handle, limit) {
  if (!handle) return [];
  try {
    const res = await fetch(
      "/collections/" + encodeURIComponent(handle) + "/products.json?limit=" + (limit || 12),
      { credentials: "same-origin" }
    );
    if (!res.ok) return [];
    const data = await res.json();
    return (data.products || []).map(mapCollectionProduct).filter(Boolean);
  } catch (_) {
    return [];
  }
}

async function fillProductRail(el) {
  if (!el) return;
  const renderer = el.dataset.card === "bestsellers" ? bestsellerCard : productCard;
  const handle = el.dataset.collectionHandle;
  let list = catalog[el.dataset.products] || [];
  if (handle) {
    const remote = await fetchCollectionProducts(handle, 16);
    if (remote.length) list = remote;
  }
  el.innerHTML = list.map(renderer).join("");
}

const productRailReady = Promise.all(
  [...document.querySelectorAll("[data-products]")].map((el) => fillProductRail(el))
);

async function initTrendMarquee(root) {
  if (!root || root.dataset.ready === "true") return;
  let topItems = catalog[root.dataset.marqueeTop] || catalog[root.dataset.marqueeProducts] || [];
  let bottomItems = catalog[root.dataset.marqueeBottom] || [...topItems].reverse();
  if (root.dataset.collectionTop) {
    const remote = await fetchCollectionProducts(root.dataset.collectionTop, 16);
    if (remote.length) topItems = remote;
  }
  if (root.dataset.collectionBottom) {
    const remote = await fetchCollectionProducts(root.dataset.collectionBottom, 16);
    if (remote.length) bottomItems = remote;
  } else if (root.dataset.collectionTop && topItems.length) {
    bottomItems = [...topItems].reverse();
  }
  if (!topItems.length || !bottomItems.length) return;
  root.dataset.ready = "true";

  const visible = Math.max(2, Number(root.dataset.visible) || 4);
  const rows = [...root.querySelectorAll("[data-marquee-dir]")];

  function fill(track, list) {
    const html = list.map(productCard).join("");
    const copies = Math.max(2, Math.ceil((visible * 2) / Math.max(list.length, 1)));
    track.innerHTML = Array.from({ length: copies }, () => html).join("");
  }

  rows.forEach((row) => {
    const track = row.querySelector("[data-marquee-track]");
    if (!track) return;
    fill(track, row.dataset.marqueeDir === "rtl" ? bottomItems : topItems);
  });

  function measure() {
    const gap = root.clientWidth < 640 ? 12 : 18;
    const cols = root.clientWidth < 640 ? 2 : root.clientWidth < 900 ? 3 : visible;
    const width = (root.clientWidth - gap * (cols - 1)) / cols;
    root.style.setProperty("--trend-gap", `${gap}px`);
    root.style.setProperty("--trend-card", `${width}px`);
    rows.forEach((row) => {
      const track = row.querySelector("[data-marquee-track]");
      if (!track) return;
      const cards = [...track.children];
      const half = cards.length / 2;
      const distance = half * (width + gap);
      const seconds = Math.max(28, distance / 38);
      track.style.setProperty("--trend-duration", `${seconds}s`);
    });
  }

  measure();
  window.addEventListener("resize", measure);
  root.addEventListener("mouseenter", () => root.classList.add("is-paused"));
  root.addEventListener("mouseleave", () => root.classList.remove("is-paused"));
}

document.querySelectorAll("[data-trend-marquee]").forEach(initTrendMarquee);

function initProductSlider(root) {
  const track = root.querySelector(".products");
  if (!track || track.dataset.ready === "true") return;
  const originals = [...track.children];
  if (originals.length < 2) return;
  track.dataset.ready = "true";
  originals.forEach((el) => track.appendChild(el.cloneNode(true)));

  let index = 0;
  let step = 0;
  let timer;
  const count = originals.length;

  function gapSize() {
    return root.clientWidth < 640 ? 12 : 18;
  }

  function visible() {
    const w = root.clientWidth;
    const max = Number(root.dataset.visible) || 4;
    const mobileMax = Number(root.dataset.mobileVisible);
    if (w < 640) {
      if (mobileMax > 0) return Math.min(mobileMax, max);
      return Math.min(2, max);
    }
    if (w < 860) return Math.min(2, max);
    if (w < 1100) return Math.min(3, max);
    return max;
  }

  function measure() {
    const vis = visible();
    const gap = gapSize();
    const width = (root.clientWidth - gap * (vis - 1)) / vis;
    [...track.children].forEach((el) => { el.style.width = `${width}px`; });
    step = width + gap;
    track.style.gap = `${gap}px`;
  }

  function paint(instant) {
    track.style.transition = instant ? "none" : "transform .45s ease";
    track.style.transform = `translateX(${-index * step}px)`;
  }

  function go(dir) {
    if (dir < 0 && index === 0) {
      index = count;
      paint(true);
      requestAnimationFrame(() => {
        index = count - 1;
        paint(false);
      });
      return;
    }
    index += dir;
    paint(false);
    if (index >= count) {
      window.setTimeout(() => {
        index = 0;
        paint(true);
      }, 460);
    }
  }

  function play() {
    clearInterval(timer);
    timer = setInterval(() => go(1), Number(root.dataset.interval) || 4200);
  }

  measure();
  paint(true);
  play();
  root.querySelector("[data-prod-prev]").addEventListener("click", () => { go(-1); play(); });
  root.querySelector("[data-prod-next]").addEventListener("click", () => { go(1); play(); });
  root.addEventListener("mouseenter", () => clearInterval(timer));
  root.addEventListener("mouseleave", play);
  window.addEventListener("resize", () => { index = 0; measure(); paint(true); });
}

productRailReady.then(() => {
  document.querySelectorAll("[data-product-slider]").forEach(initProductSlider);
});

/* 5 mains lead the strip; extras show on desktop only (CSS). Slide on all viewports. */
const mainCatHandles = ["crockery", "decor", "bedding", "electronics", "luggage-bags"];
const featuredHandles = [
  ...mainCatHandles,
  "dinner-sets", "tea-sets", "turkish-crockery", "planters", "candle-stands",
  "bathroom-sets", "cups-and-saucers", "mugs", "glasses", "vases",
  "candy-jars", "flowers", "bedsheets-velvet", "comforter-sets", "wall-clocks"
];

function shopImage(src, width = 280) {
  if (!src) return "";
  let out = String(src)
    .replace("https://mannacrockery.pk/cdn/shop/", "https://cdn.shopify.com/s/files/1/0705/6483/9574/");
  if (/[?&]width=/.test(out)) out = out.replace(/([?&]width=)\d+/g, `$1${width}`);
  else out += (out.includes("?") ? "&" : "?") + `width=${width}`;
  return out;
}

function countLabel(n) {
  return n >= 100 ? `${n}+ items` : `${n} items`;
}

function cardHtml(c) {
  const tier = mainCatHandles.includes(c.handle) ? "main" : "extra";
  return `<a class="cat" data-cat-tier="${tier}" href="/collections/${c.handle}" draggable="false">
    <span class="cat__img"><img src="${shopImage(c.img, 280)}" alt="${c.title}" loading="lazy" decoding="async" width="280" height="280"></span>
    <strong>${c.title.replace(" Collection", "")}</strong>
    <small>${countLabel(c.count)}</small>
  </a>`;
}

const fallbackCats = [
  { handle: "crockery", title: "Crockery", count: 2136, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/crockery-moockup-550-new-website.webp?v=1768997176" },
  { handle: "dinner-sets", title: "Dinner Sets", count: 87, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/dinner-sets-premium.jpg?v=1792234104" },
  { handle: "tea-sets", title: "Tea Sets", count: 113, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/tea-sets-premium.jpg?v=1792234133" },
  { handle: "turkish-crockery", title: "Turkish Crockery", count: 78, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/turkish-crockery-front_e99cfdbc-15af-4bbf-8c60-1361253add4e.jpg?v=1792233822" },
  { handle: "soup-sets", title: "Soup Sets", count: 55, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/soup-sets-premium.jpg?v=1792234138" },
  { handle: "ice-cream-sets", title: "Ice Cream Sets", count: 48, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/IMG-9225.png?v=1792233827" },
  { handle: "breakfast-set", title: "Breakfast Sets", count: 25, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/breakfast-set-premium.jpg?v=1792234144" },
  { handle: "plate-set", title: "Plate Sets", count: 64, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/plate-set-premium.jpg?v=1792234151" },
  { handle: "melamine-dinner-sets", title: "Melamine Dinner Sets", count: 82, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/melamine-dinner-sets-premium.jpg?v=1792234158" },
  { handle: "cups-and-saucers", title: "Cups and Saucers", count: 124, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/cups-and-saucers-premium.jpg?v=1792234166" },
  { handle: "mugs", title: "Mugs", count: 175, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/mugs-premium.jpg?v=1792234172" },
  { handle: "glasses", title: "Glasses", count: 137, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/glasses-premium.jpg?v=1792234179" },
  { handle: "glass-ware-dishes", title: "Glass ware Dishes", count: 32, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/glass-ware-dishes-premium.jpg?v=1792234185" },
  { handle: "water-sets", title: "Water Sets", count: 38, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/water-sets-premium.jpg?v=1792234193" },
  { handle: "water-dispensers", title: "Water Dispensers", count: 47, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/water-dispensers-premium.jpg?v=1792234199" },
  { handle: "water-bottles", title: "Water Bottles", count: 12, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/water-bottles-premium.jpg?v=1792234207" },
  { handle: "hotpots", title: "Hotpots", count: 44, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/hotpots-premium.jpg?v=1792234216" },
  { handle: "buffet-dishes", title: "Buffet Dishes", count: 68, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/buffet-dishes-premium.jpg?v=1792234223" },
  { handle: "platters", title: "Platters", count: 105, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/platters-premium.jpg?v=1792234231" },
  { handle: "pastry-dishes", title: "Pastry dishes", count: 25, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/pastry-dishes-premium.jpg?v=1792234239" },
  { handle: "dry-fruit-dishes", title: "Dry Fruit Dishes", count: 46, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/dry-fruit-dishes-premium.jpg?v=1792234247" },
  { handle: "cake-sets", title: "Cake Sets", count: 28, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/cake-sets-premium.jpg?v=1792234254" },
  { handle: "cake-dishes", title: "Cake Dishes", count: 24, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/cake-dishes-premium.jpg?v=1792234262" },
  { handle: "loose-plates", title: "Loose Plates", count: 69, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/loose-plates-premium.jpg?v=1792234268" },
  { handle: "cutlery", title: "Cutlery", count: 31, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/cutlery-premium.jpg?v=1792234275" },
  { handle: "knife-sets", title: "Knife Sets", count: 22, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/knife-sets-premium.jpg?v=1792234281" },
  { handle: "non-stick-set", title: "Non Stick Sets", count: 33, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/non-stick-set-premium.jpg?v=1792234288" },
  { handle: "silver-steel-cookware", title: "Silver Steel Cookware", count: 2, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/silver-steel-cookware-premium.jpg?v=1792234295" },
  { handle: "pressure-cooker", title: "Pressure Cooker", count: 21, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/pressure-cooker-premium.jpg?v=1792234303" },
  { handle: "kitchen-accessories", title: "Kitchen Accessories", count: 71, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/kitchen-accessories-premium.jpg?v=1792234310" },
  { handle: "thermoses", title: "Thermoses", count: 44, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/thermoses-premium.jpg?v=1792234317" },
  { handle: "cool-sets", title: "Cool Sets", count: 16, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/cool-sets-premium.jpg?v=1792234325" },
  { handle: "hotel-ware", title: "Hotel Ware", count: 13, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/hotalware-front-mockup-34_b35f9f91-5ffa-4e13-bba9-1ba3f438e72c.jpg?v=1768999373" },
  { handle: "crystal-versace", title: "Crystal Versace", count: 16, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/crystal-versace-premium.jpg?v=1792234331" },
  { handle: "table-mats", title: "Table Mats", count: 35, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/decor-mats.png?v=1769804941" },
  { handle: "decor", title: "Decor", count: 1881, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/decor-front-mockup_a63a72fc-aac3-4d23-8649-93724058af73.jpg?v=1768998373" },
  { handle: "planters", title: "Planters", count: 123, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/planters-front-web-banner-550-size_d2acab4a-f0e0-4b63-adc6-da1dafdf1dbe.jpg?v=1768997665" },
  { handle: "vases", title: "Vases", count: 196, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/vases-premium.jpg?v=1792234337" },
  { handle: "candy-jars", title: "Candy Jars", count: 129, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/decor-candy-jars.png?v=1769802857" },
  { handle: "candle-stands", title: "Candle Stands", count: 261, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/candle-stands-premium.jpg?v=1792234344" },
  { handle: "candles", title: "Candles", count: 44, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/candles-premium.jpg?v=1792234350" },
  { handle: "flowers", title: "Flowers", count: 91, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/decor-flowers.png?v=1769803299" },
  { handle: "statues", title: "Statues", count: 91, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/statues-premium.jpg?v=1792234356" },
  { handle: "paintings", title: "Paintings", count: 174, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/paintings-premium.jpg?v=1792234364" },
  { handle: "wall-hangings", title: "Wall Hangings", count: 19, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/wall-hangings-premium.jpg?v=1792234370" },
  { handle: "photo-frames", title: "Photo Frames", count: 18, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/photo-frames-premium.jpg?v=1792234377" },
  { handle: "bathroom-sets", title: "Bathroom Sets", count: 109, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/12000_b3009d85-6d38-4f73-9dbc-69c7002f7b6d.jpg?v=1776029843" },
  { handle: "tissue-boxes", title: "Tissue Boxes", count: 68, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/tissue-boxes-premium.jpg?v=1792234383" },
  { handle: "dustbins", title: "Dustbins", count: 56, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/dustbins-premium.jpg?v=1792234391" },
  { handle: "laundry-baskets", title: "Laundry Baskets", count: 26, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/laundry-baskets-premium.jpg?v=1792234399" },
  { handle: "lanterns-sets", title: "Lanterns Sets", count: 11, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/lanterns-sets-premium.jpg?v=1792234407" },
  { handle: "perfume-trays", title: "Perfume Trays", count: 35, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/perfume-trays-premium.jpg?v=1792234413" },
  { handle: "centre-table-pieces", title: "Centre Table Pieces", count: 4, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/centre-table-pieces-premium.jpg?v=1792234420" },
  { handle: "tea-trolleys", title: "Tea Trolleys", count: 22, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/tea-trolleys-premium.jpg?v=1792234427" },
  { handle: "wall-clocks", title: "Wall Clocks", count: 58, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/wall-clocks-premium.jpg?v=1792234433" },
  { handle: "decor-table-clocks", title: "Table Clocks", count: 38, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/decor-table-clocks-premium_00216be6-e7e0-4cd2-b46e-41bbd8bd3304.jpg?v=1792234563" },
  { handle: "table-lamps", title: "Table Lamps", count: 7, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/table-lamps-premium.jpg?v=1792234464" },
  { handle: "floor-lamp", title: "Floor lamp", count: 24, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/floor-lamp-premium.jpg?v=1792234471" },
  { handle: "mirror", title: "Mirror", count: 5, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/decor-stand-mirror.png?v=1769804813" },
  { handle: "dummy-books", title: "Dummy Books", count: 9, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/dummy-books-premium.jpg?v=1792234478" },
  { handle: "book-ends", title: "Book Ends", count: 10, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/book-ends-premium.jpg?v=1792234486" },
  { handle: "decor-nesting-table", title: "Nesting Table", count: 10, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/decor-nesting-table-premium.jpg?v=1792234493" },
  { handle: "bedding", title: "Bedding", count: 426, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/bedding-front-web-mockup-550_01f9ed27-004f-4a14-af6a-bc1eff91f442.jpg?v=1768999256" },
  { handle: "bedsheets-velvet", title: "Bedsheets Velvet", count: 205, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/bedsheets-velvet-premium.jpg?v=1792234503" },
  { handle: "comforter-sets", title: "Comforter Sets", count: 33, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/comforter-sets-premium.jpg?v=1792234510" },
  { handle: "bridal-sets", title: "Bridal Sets", count: 31, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/bridal-sets-premium.jpg?v=1792234516" },
  { handle: "fleece", title: "Fleece", count: 85, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/fleece-premium.jpg?v=1792234522" },
  { handle: "single-blankets", title: "Single Blankets", count: 61, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/singles-blankets.png?v=1769769805" },
  { handle: "double-blankets", title: "Double Blankets", count: 61, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/double-blankets-premium.jpg?v=1792234531" },
  { handle: "blanket-sets", title: "Blanket Sets", count: 5, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/blanket-sets-premium.jpg?v=1792234540" },
  { handle: "razai", title: "Razai", count: 10, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/razai-premium.jpg?v=1792234546" },
  { handle: "razai-covers", title: "Razai Covers", count: 10, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/razai-cover.png?v=1769771769" },
  { handle: "electronics", title: "Electronics", count: 59, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/electronics-front-web-mockup-550_b7f767d7-9408-42fe-b984-51a8c02de163.jpg?v=1768999111" },
  { handle: "luggage-bags", title: "Luggage Bags", count: 23, img: "https://cdn.shopify.com/s/files/1/0705/6483/9574/collections/Suit-case-web-front-mockup-550_36d33306-f400-4637-b2cc-23f42b293cef.jpg?v=1768998552" },
];

async function loadCollections() {
  const all = [];
  const seen = new Set();
  for (let page = 1; page <= 6; page += 1) {
    try {
      const res = await fetch(`/collections.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const data = await res.json();
      const list = data.collections || [];
      if (!list.length) break;
      list.forEach((c) => {
        if (!c.handle || seen.has(c.handle) || c.handle === "all" || c.handle.endsWith("-1")) return;
        if (c.handle === "suit-case") return; // renamed → luggage-bags
        const img = (c.image && c.image.src) || "";
        if (!img && !mainCatHandles.includes(c.handle)) return;
        seen.add(c.handle);
        all.push({
          handle: c.handle,
          title: c.title,
          count: c.products_count || 0,
          img
        });
      });
      if (list.length < 50) break;
    } catch {
      break;
    }
  }
  if (!seen.has("luggage-bags")) {
    const fb = fallbackCats.find((c) => c.handle === "luggage-bags");
    if (fb) all.push({ ...fb });
  }
  if (!all.length) return fallbackCats.slice();
  const aiCovers = (typeof window !== "undefined" && window.__manaAiCovers) || {};
  return all
    .map((c) => {
      const fb = fallbackCats.find((f) => f.handle === c.handle);
      // AI covers (Sidekick / generated) > curated fallback > live Shopify image
      const img = aiCovers[c.handle] || (fb && fb.img) || c.img || "";
      return { ...c, ...fb, handle: c.handle, title: c.title || fb?.title, count: c.count || fb?.count || 0, img };
    })
    .filter((c) => c.img)
    .sort((a, b) => {
      const ai = featuredHandles.indexOf(a.handle);
      const bi = featuredHandles.indexOf(b.handle);
      if (ai !== -1 || bi !== -1) return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      return a.title.localeCompare(b.title);
    });
}

function initLoopSlider(root) {
  const track = root.querySelector("[data-loop-track]");
  if (!track || track.children.length < 2 || track.dataset.ready === "true") return;
  track.dataset.ready = "true";
  const originals = [...track.children];
  const shouldClone = root.dataset.loopClone !== "false";
  if (shouldClone) originals.forEach((el) => track.appendChild(el.cloneNode(true)));

  // Transform marquee: reliable on iOS/iPad (scrollLeft auto-tick is flaky there)
  root.classList.add("is-loop-ready");
  track.classList.add("is-loop-track");
  track.style.willChange = "transform";

  let offset = 0;
  let paused = false;
  let dragging = false;
  let moved = false;
  let startX = 0;
  let startOffset = 0;
  let resumeTimer;
  let mid = 0;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const speed = Number(root.dataset.loopSpeed) || 0.55;

  const measure = () => {
    if (!shouldClone) {
      mid = Math.max(0, track.scrollWidth - (root.clientWidth || track.parentElement?.clientWidth || 0));
      return;
    }
    // First half width = sum of original children (+ gaps via offsetLeft of first clone)
    const cloneStart = originals.length;
    const firstClone = track.children[cloneStart];
    mid = firstClone ? firstClone.offsetLeft : Math.floor(track.scrollWidth / 2);
  };
  const apply = () => {
    if (shouldClone && mid > 0) {
      while (offset >= mid) offset -= mid;
      while (offset < 0) offset += mid;
    } else if (!shouldClone && mid > 0) {
      if (offset > mid) offset = 0;
      if (offset < 0) offset = mid;
    }
    track.style.transform = `translate3d(${-offset}px,0,0)`;
  };
  const pauseThenResume = (ms = 1600) => {
    paused = true;
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(() => { if (!dragging) paused = false; }, ms);
  };

  measure();
  apply();
  // Re-measure after images/layout settle (mobile Safari)
  requestAnimationFrame(() => { measure(); apply(); });
  window.addEventListener("resize", () => { measure(); apply(); }, { passive: true });
  if (typeof ResizeObserver !== "undefined") {
    const ro = new ResizeObserver(() => { measure(); apply(); });
    ro.observe(track);
    ro.observe(root);
  }

  if (!reduce) {
    const tick = () => {
      if (!paused && !dragging && mid > 0) {
        offset += speed;
        apply();
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  const onPointerDown = (e) => {
    if (e.pointerType === "mouse" && e.button !== 0) return;
    if (e.target.closest("button, iframe")) return;
    dragging = true;
    moved = false;
    paused = true;
    startX = e.clientX;
    startOffset = offset;
    try { track.setPointerCapture(e.pointerId); } catch (_) {}
    track.classList.add("is-dragging");
  };
  const onPointerMove = (e) => {
    if (!dragging) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 6) moved = true;
    offset = startOffset - dx;
    apply();
    // Keep vertical page scroll free; only block default once we commit to horizontal drag
    if (moved) e.preventDefault();
  };
  const endDrag = () => {
    if (!dragging) return;
    dragging = false;
    track.classList.remove("is-dragging");
    pauseThenResume(2000);
  };

  track.addEventListener("pointerdown", onPointerDown);
  track.addEventListener("pointermove", onPointerMove, { passive: false });
  track.addEventListener("pointerup", endDrag);
  track.addEventListener("pointercancel", endDrag);
  track.addEventListener("lostpointercapture", endDrag);
  track.addEventListener("click", (e) => {
    if (moved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  track.addEventListener("wheel", (e) => {
    const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    offset += delta;
    apply();
    e.preventDefault();
    pauseThenResume();
  }, { passive: false });
  root.addEventListener("mouseenter", () => { paused = true; });
  root.addEventListener("mouseleave", () => { if (!dragging) paused = false; });
}

function initHeroSlider(root) {
  const slides = [...root.querySelectorAll("[data-hero-slide]")];
  if (slides.length < 2) return;
  const dotsWrap = root.querySelector("[data-hero-dots]");
  if (dotsWrap) {
    dotsWrap.innerHTML = slides.map((_, i) => `<button type="button" aria-label="Go to slide ${i + 1}"></button>`).join("");
  }
  let index = 0;
  const ms = Number(root.dataset.heroInterval) || 6000;
  // Quick zoom in/out - not a full-slide slow Ken Burns
  root.style.setProperty("--hero-zoom-ms", "900ms");

  const arm = (el) => {
    if (!el) return;
    const img = el.matches("img") ? el : el.querySelector("img");
    if (!img || img.getAttribute("src")) return;
    const src = img.getAttribute("data-src");
    const srcset = img.getAttribute("data-srcset");
    if (src) {
      img.setAttribute("src", src);
      img.removeAttribute("data-src");
    }
    if (srcset) {
      img.setAttribute("srcset", srcset);
      img.removeAttribute("data-srcset");
    }
  };
  const show = (n) => {
    arm(slides[n]);
    arm(slides[(n + 1) % slides.length]);
    slides.forEach((el, i) => {
      const active = i === n;
      const img = el.matches("img") ? el : el.querySelector(".hero__bg, .mana-hero__bg, img");
      el.classList.toggle("is-active", active);
      el.classList.toggle("is-zoom-out", active && n % 2 === 1);
      if (active && img) {
        img.style.animation = "none";
        void img.offsetWidth;
        img.style.animation = "";
      }
    });
    if (dotsWrap) {
      [...dotsWrap.children].forEach((dot, i) => dot.classList.toggle("is-active", i === n));
    }
  };
  show(0);
  let timer = setInterval(() => {
    index = (index + 1) % slides.length;
    show(index);
  }, ms);
  const restart = () => {
    clearInterval(timer);
    timer = setInterval(() => {
      index = (index + 1) % slides.length;
      show(index);
    }, ms);
  };
  if (dotsWrap) {
    dotsWrap.addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      index = [...dotsWrap.children].indexOf(btn);
      show(index);
      restart();
    });
  }
  root.addEventListener("mouseenter", () => clearInterval(timer));
  root.addEventListener("mouseleave", restart);
}

document.querySelectorAll("[data-hero-slider]").forEach(initHeroSlider);
document.querySelectorAll("[data-loop-slider]").forEach(initLoopSlider);

(async () => {
  const items = await loadCollections();
  const catsRoot = document.querySelector("#categories");
  const catsTrack = catsRoot && catsRoot.querySelector("[data-loop-track]");
  if (catsTrack && !catsTrack.dataset.ready) {
    catsTrack.innerHTML = items.map(cardHtml).join("");
    delete catsRoot.dataset.loopClone;
    initLoopSlider(catsRoot);
  }
})();

const shop = {
  cart: JSON.parse(localStorage.getItem("mana_cart") || "[]"),
  wish: JSON.parse(localStorage.getItem("mana_wish") || "[]"),
  compare: JSON.parse(localStorage.getItem("mana_compare") || "[]")
};

function saveShop() {
  localStorage.setItem("mana_cart", JSON.stringify(shop.cart));
  localStorage.setItem("mana_wish", JSON.stringify(shop.wish));
  localStorage.setItem("mana_compare", JSON.stringify(shop.compare));
}

function findProduct(id) {
  return products.find((p) => p.id === id);
}

/* Same Shopify CDN reels as local-preview/home.js — overridden by window.__manaHomeConfig.reels when set from theme editor */
const reelsFallback = [
  { id: "imperial-dinner", video: "https://cdn.shopify.com/videos/c/o/v/c847652bcc2a4206849392b03fb25593.mp4" },
  { collection: "dinner-sets", video: "https://cdn.shopify.com/videos/c/o/v/6d3159c5c1a4498da918fa40c67a5eac.mp4" },
  { id: "candle-stand-gold", video: "https://cdn.shopify.com/videos/c/o/v/0d5ca8cf05214e698a7125c3d1aa3e42.mp4" },
  { collection: "candle-stands", video: "https://cdn.shopify.com/videos/c/o/v/d1fc90e69af145dfb2d5ad8f0b132889.mp4" },
  { id: "glass-candle-stand", video: "https://cdn.shopify.com/videos/c/o/v/f6cb6b6b27584ce4915e5b29cb642fb9.mp4" },
  { collection: "tea-sets", video: "https://cdn.shopify.com/videos/c/o/v/65dffbe1f0ea4964a60a0c5ab32bde51.mp4" },
  { id: "stoneware-dinner", video: "https://cdn.shopify.com/videos/c/o/v/22a515402a2c4524860049e777266d98.mp4" }
];
const homeCfg = window.__manaHomeConfig || {};
const reels = Array.isArray(homeCfg.reels) && homeCfg.reels.length
  ? homeCfg.reels.filter((r) => r && r.video)
  : reelsFallback;
const reelsOrderLabel = homeCfg.orderLabel || "Order now - Cash on delivery";
const reelsExploreLabel = homeCfg.exploreLabel || "Explore";

function reelSoundBtn() {
  return `<button type="button" class="reel__sound" data-reel-sound aria-pressed="false" aria-label="Unmute reel">
    <svg class="reel__sound-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="m16 9 6 6M22 9l-6 6"/></svg>
    <svg class="reel__sound-on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 010 7"/><path d="M18.5 6.5a8.5 8.5 0 010 11"/></svg>
  </button>`;
}

function reelCollectionMeta(handle) {
  if (!handle) return null;
  const aliases = handle === "candle-stand" ? ["candle-stand", "candle-stands"] : [handle];
  for (const h of aliases) {
    const hit = fallbackCats.find((c) => c.handle === h);
    if (hit) return hit;
  }
  return null;
}

function reelCard(entry) {
  if (entry.productHandle || entry.productUrl) {
    const pdp = entry.productUrl || `/products/${encodeURIComponent(entry.productHandle)}`;
    const title = entry.productTitle || entry.productHandle;
    const price = entry.productPrice || "";
    const img = entry.productImg || "";
    const btn = entry.buttonLabel || "Add to cart";
    return `
  <article class="reel product" data-id="${entry.productHandle || ""}" data-reel-key="ph-${entry.productHandle || entry.video}">
    <div class="reel__media">
      <video class="reel__video" data-src="${entry.video}" muted loop playsinline preload="none"></video>
      ${reelSoundBtn()}
      <div class="reel__shop">
        <div class="reel__product">
          <a href="${pdp}">${img ? `<img src="${img}" alt="">` : ""}</a>
          <div>
            <strong><a href="${pdp}">${title}</a></strong>
            ${price ? `<span>${price}</span>` : ""}
          </div>
        </div>
        <a class="reel__cart" href="${pdp}">${btn}</a>
      </div>
    </div>
    <a class="reel__cod" href="${pdp}">${reelsOrderLabel}</a>
  </article>`;
  }
  if (entry.collectionTitle || entry.collectionUrl) {
    const href = entry.collectionUrl || `/collections/${encodeURIComponent(entry.collection)}`;
    const title = entry.collectionTitle || entry.collection;
    const img = entry.collectionImg || "";
    const btn = entry.buttonLabel || title;
    return `
  <article class="reel" data-reel-key="col-${entry.collection || title}">
    <div class="reel__media">
      <video class="reel__video" data-src="${entry.video}" muted loop playsinline preload="none"></video>
      ${reelSoundBtn()}
      <div class="reel__shop">
        <div class="reel__product">
          ${img ? `<img src="${img}" alt="">` : ""}
          <div>
            <strong>${title}</strong>
          </div>
        </div>
        <a class="reel__cart" href="${href}">${btn}</a>
      </div>
    </div>
    <a class="reel__cod" href="${href}">${reelsExploreLabel} ${title}</a>
  </article>`;
  }
  const col = reelCollectionMeta(entry.collection);
  if (col) {
    const href = `/collections/${encodeURIComponent(col.handle)}`;
    return `
  <article class="reel" data-reel-key="col-${col.handle}">
    <div class="reel__media">
      <video class="reel__video" data-src="${entry.video}" muted loop playsinline preload="none"></video>
      ${reelSoundBtn()}
      <div class="reel__shop">
        <div class="reel__product">
          <img src="${col.img}" alt="">
          <div>
            <strong>${col.title}</strong>
          </div>
        </div>
        <a class="reel__cart" href="${href}">${col.title}</a>
      </div>
    </div>
    <a class="reel__cod" href="${href}">${reelsExploreLabel} ${col.title}</a>
  </article>`;
  }
  const p = findProduct(entry.id);
  if (!p) {
    return `
  <article class="reel" data-reel-key="${entry.video}">
    <div class="reel__media">
      <video class="reel__video" data-src="${entry.video}" muted loop playsinline preload="none"></video>
      ${reelSoundBtn()}
    </div>
  </article>`;
  }
  const pdp = p.url || `/products/${encodeURIComponent(p.handle || p.id)}`;
  return `
  <article class="reel product" data-id="${p.id}" data-reel-key="p-${p.id}">
    <div class="reel__media">
      <video class="reel__video" data-src="${entry.video}" muted loop playsinline preload="none"></video>
      ${reelSoundBtn()}
      <div class="reel__shop">
        <div class="reel__product">
          <a href="${pdp}"><img src="${p.img}" alt=""></a>
          <div>
            <strong><a href="${pdp}">${p.title}</a></strong>
            <span>${p.price}</span>
          </div>
        </div>
        <button type="button" class="reel__cart" data-act="cart">Add to cart</button>
      </div>
    </div>
    <button type="button" class="reel__cod" data-act="book">${reelsOrderLabel}</button>
  </article>`;
}

function initReelsSlider(root, attempt) {
  if (window.ManaReels && typeof window.ManaReels.init === "function") {
    window.ManaReels.init(root);
    return;
  }
  const n = attempt || 0;
  if (n < 20) {
    window.setTimeout(() => initReelsSlider(root, n + 1), 50);
  }
}

const reelsRoot = document.querySelector("[data-reels]");
if (reelsRoot) {
  const track = reelsRoot.querySelector("[data-reels-track]");
  const boot = () => {
    if (!track || track.dataset.booted === "true") return;
    track.dataset.booted = "true";
    if (track.dataset.fromLiquid === "true" && !reels.length) {
      initReelsSlider(reelsRoot);
      return;
    }
    track.innerHTML = reels.map(reelCard).join("");
    initReelsSlider(reelsRoot);
  };
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        io.disconnect();
        boot();
      }
    }, { rootMargin: "200px 0px" });
    io.observe(reelsRoot);
  } else {
    boot();
  }
}

function toast(msg) {
  const el = document.getElementById("toast");
  if (!el) return;
  el.textContent = msg;
  el.hidden = false;
  clearTimeout(toast.t);
  toast.t = setTimeout(() => { el.hidden = true; }, 1800);
}

function cartCount() {
  return shop.cart.reduce((n, i) => n + i.qty, 0);
}

function paintCounts() {
  const map = { wish: shop.wish.length, compare: shop.compare.length, cart: cartCount() };
  document.querySelectorAll("[data-count]").forEach((el) => {
    const n = map[el.dataset.count] || 0;
    el.textContent = n || "";
    el.dataset.empty = n ? "false" : "true";
  });
  document.querySelectorAll(".product").forEach((card) => {
    const id = card.dataset.id;
    card.querySelectorAll('[data-act="wish"]').forEach((el) => el.classList.toggle("is-on", shop.wish.includes(id)));
    card.querySelectorAll('[data-act="compare"]').forEach((el) => el.classList.toggle("is-on", shop.compare.includes(id)));
  });
  document.querySelector('.mana-icons [data-open="wish"], .icons [data-open="wish"]')?.classList.toggle("is-visible", shop.wish.length > 0);
}

function toggleList(key, id, limit) {
  const i = shop[key].indexOf(id);
  if (i >= 0) shop[key].splice(i, 1);
  else {
    if (limit && shop[key].length >= limit) {
      toast(`Compare up to ${limit} products`);
      return;
    }
    shop[key].push(id);
  }
  saveShop();
  paintCounts();
}

function addCart(id) {
  const row = shop.cart.find((i) => i.id === id);
  if (row) row.qty += 1;
  else shop.cart.push({ id, qty: 1 });
  saveShop();
  paintCounts();
}

function removeCart(id) {
  shop.cart = shop.cart.filter((i) => i.id !== id);
  saveShop();
  paintCounts();
}

function money(n) {
  return `Rs.${n.toLocaleString("en-PK")}`;
}

function renderWish() {
  const box = document.querySelector('[data-list="wish"]');
  const actions = document.querySelector("[data-wish-actions]");
  if (!box || !actions) return;
  if (!shop.wish.length) {
    box.innerHTML = "<p>No saved pieces yet.</p>";
    actions.innerHTML = "";
    return;
  }
  box.innerHTML = shop.wish.map((id) => {
    const p = findProduct(id);
    return `<div class="sheet-row">
      <img src="${p.img}" alt="">
      <div><strong>${p.title}</strong><span>${p.price}</span></div>
      <button type="button" data-remove-wish="${id}">Remove</button>
    </div>`;
  }).join("");
  const names = shop.wish.map((id) => findProduct(id).title).join(", ");
  const msg = encodeURIComponent(`I would like to enquire about my favorites: ${names}.`);
  actions.innerHTML = `
    <a class="btn btn-gold" href="https://wa.me/923114711112?text=${msg}">Enquire on WhatsApp</a>
    <button type="button" class="btn btn-dark" data-wish-cart>Add all to cart</button>`;
}

function renderCart() {
  const box = document.querySelector('[data-list="cart"]');
  const foot = document.querySelector("[data-cart-foot]");
  if (!box || !foot) return;
  if (!shop.cart.length) {
    box.innerHTML = "<p>Your cart is empty.</p>";
    foot.innerHTML = "";
    return;
  }
  const rows = shop.cart.map((item) => ({ item, p: findProduct(item.id) })).filter((r) => r.p);
  if (!rows.length) {
    box.innerHTML = "<p>Your cart is empty.</p>";
    foot.innerHTML = "";
    return;
  }
  box.innerHTML = rows.map(({ item, p }) => `<div class="sheet-row">
      <img src="${p.img || ""}" alt="">
      <div><strong>${p.title}</strong><span>${p.price} × ${item.qty}</span></div>
      <button type="button" data-remove-cart="${item.id}">Remove</button>
    </div>`).join("");
  const total = rows.reduce((n, { item, p }) => n + (p.amount || 0) * item.qty, 0);
  const lines = rows.map(({ item, p }) => `${p.title} × ${item.qty}`).join(", ");
  const wa = `I would like to order: ${lines}. Total ${money(total)}.`;
  const msg = encodeURIComponent(wa);
  foot.innerHTML = (typeof window.manaCartFootHTML === "function")
    ? window.manaCartFootHTML(`Total ${money(total)}`, wa)
    : `<div>Total ${money(total)}</div><div class="sheet__actions"><button type="button" class="btn btn-dark" data-checkout>Checkout</button><a class="btn btn-gold" href="https://wa.me/923114711112?text=${msg}">Order on WhatsApp</a></div>`;
}

let compareOpen = false;

function renderCompare() {
  const box = document.querySelector('[data-list="compare"]');
  if (!box) return;
  if (!shop.compare.length) {
    compareOpen = false;
    box.innerHTML = "<p>Add products to compare.</p>";
    return;
  }
  const cols = shop.compare.length;
  box.innerHTML = `
    <div class="compare-bar">
      <p>Open these products to see full details in each column, like a product page.</p>
      <button type="button" class="btn ${compareOpen ? "btn-dark" : "btn-gold"}" data-open-pdp>${compareOpen ? "Hide details" : "Open these products"}</button>
    </div>
    <div class="compare-grid" style="--cols:${cols}">${shop.compare.map((id) => {
    const p = findProduct(id);
    const gallery = p.images && p.images.length ? p.images : [p.img];
    return `<article class="compare-card${compareOpen ? " is-open" : ""}">
      <div class="cmp-media" data-cmp-slider data-index="0">
        ${gallery.map((src, i) => `<img class="${i === 0 ? "is-active" : ""}" src="${src}" alt="${p.title}">`).join("")}
        <button type="button" class="cmp-media__nav" data-cmp-prev aria-label="Previous image">‹</button>
        <button type="button" class="cmp-media__nav cmp-media__nav--next" data-cmp-next aria-label="Next image">›</button>
        <div class="cmp-media__dots">${gallery.map((_, i) => `<span data-cmp-dot class="${i === 0 ? "is-active" : ""}"></span>`).join("")}</div>
      </div>
      <div class="compare-card__info">
        <strong>${p.title}</strong>
        <div class="price">${p.compare ? `<span class="old">${p.compare}</span>` : ""}<span class="${p.compare ? "sale-price" : ""}">${p.price}</span></div>
        <div class="stars">★★★★★</div>
      </div>
      <div class="compare-pdp">
        <p>${p.desc}</p>
        <dl>
          <div><dt>Material</dt><dd>${p.material}</dd></div>
          <div><dt>Set</dt><dd>${p.pieces}</dd></div>
          <div><dt>Care</dt><dd>${p.care}</dd></div>
          <div><dt>SKU</dt><dd>${p.sku}</dd></div>
        </dl>
      </div>
      <div class="compare-card__actions">
        <button type="button" class="btn btn-dark" data-act="cart" data-id="${id}">Add to cart</button>
        <button type="button" class="btn btn-gold" data-remove-compare="${id}">Remove</button>
      </div>
    </article>`;
  }).join("")}</div>`;

  box.querySelectorAll("[data-cmp-slider]").forEach((root) => {
    let startX = 0;
    root.addEventListener("pointerdown", (e) => { startX = e.clientX; });
    root.addEventListener("pointerup", (e) => {
      const move = e.clientX - startX;
      if (Math.abs(move) < 36) return;
      const btn = root.querySelector(move < 0 ? "[data-cmp-next]" : "[data-cmp-prev]");
      if (btn) btn.click();
    });
  });
}

function renderBook(id) {
  const p = findProduct(id);
  const box = document.querySelector('[data-list="book"]');
  const actions = document.querySelector("[data-book-actions]");
  if (!p || !box || !actions) return;
  const msg = encodeURIComponent(`I want to book ${p.title} (${p.price}) from Manna Crockery.`);
  box.innerHTML = `<div class="sheet-row">
    <img src="${p.img}" alt="">
    <div><strong>${p.title}</strong><span>${p.price}</span></div>
  </div>`;
  actions.innerHTML = `
    <a class="btn btn-gold" href="https://wa.me/923114711112?text=${msg}">Book on WhatsApp</a>
    <button type="button" class="btn btn-dark" data-act="cart" data-id="${id}">Add to cart</button>`;
}

function openSheet(name, id) {
  const sheet = document.getElementById(`sheet-${name}`);
  if (!sheet) return;
  closeMenu();
  if (name === "wish") renderWish();
  if (name === "cart") renderCart();
  if (name === "compare") renderCompare();
  if (name === "book") renderBook(id);
  document.querySelectorAll(".sheet").forEach((s) => { s.hidden = true; });
  sheet.hidden = false;
}

function closeSheets() {
  document.querySelectorAll(".sheet").forEach((s) => { s.hidden = true; });
}

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".product [data-act]");
  if (!btn) return;
  const card = btn.closest(".product");
  const id = card.dataset.id;
  const act = btn.dataset.act;
  if (act === "wish") {
    toggleList("wish", id);
    toast(shop.wish.includes(id) ? "Saved to wishlist" : "Removed from wishlist");
  }
  if (act === "compare") {
    toggleList("compare", id, 3);
    if (shop.compare.includes(id)) toast("Added to compare");
  }
  if (act === "cart") {
    addCart(id);
    toast("Added to cart");
  }
  if (act === "book") openSheet("book", id);
});

document.querySelectorAll("[data-open]").forEach((btn) => {
  btn.addEventListener("click", () => {
    const name = btn.dataset.open;
    if (name === "wish") renderWish();
    if (name === "cart") renderCart();
    if (name === "compare") renderCompare();
    openSheet(name);
  });
});

document.querySelectorAll("[data-close]").forEach((btn) => {
  btn.addEventListener("click", closeSheets);
});
document.querySelectorAll(".sheet").forEach((sheet) => {
  sheet.addEventListener("click", (e) => {
    if (e.target === sheet) closeSheets();
    const wishId = e.target.dataset.removeWish;
    const cartId = e.target.dataset.removeCart;
    const cmpId = e.target.dataset.removeCompare;
    if (wishId) { shop.wish = shop.wish.filter((id) => id !== wishId); saveShop(); paintCounts(); renderWish(); }
    if (cartId) { removeCart(cartId); renderCart(); }
    if (cmpId) { shop.compare = shop.compare.filter((id) => id !== cmpId); saveShop(); paintCounts(); renderCompare(); }
    const act = e.target.closest("[data-act]");
    if (act && act.dataset.act === "cart") {
      addCart(act.dataset.id);
      toast("Added to cart");
      renderCart();
    }
    if (e.target.closest("[data-wish-cart]")) {
      shop.wish.forEach((id) => addCart(id));
      toast("Favorites added to cart");
      renderCart();
    }
    if (e.target.closest("[data-open-pdp]")) {
      compareOpen = !compareOpen;
      renderCompare();
    }
    const sliderBtn = e.target.closest("[data-cmp-prev], [data-cmp-next]");
    if (sliderBtn) {
      const root = sliderBtn.closest("[data-cmp-slider]");
      const slides = [...root.querySelectorAll("img")];
      let i = Number(root.dataset.index || 0);
      i = (i + (sliderBtn.hasAttribute("data-cmp-next") ? 1 : -1) + slides.length) % slides.length;
      root.dataset.index = String(i);
      slides.forEach((img, n) => img.classList.toggle("is-active", n === i));
      root.querySelectorAll("[data-cmp-dot]").forEach((dot, n) => dot.classList.toggle("is-active", n === i));
    }
  });
});

paintCounts();

const searchRoot = document.getElementById("search");
const searchInput = document.getElementById("search-input");
const searchBox = document.querySelector("[data-search-results]");
let searchTimer = 0;
let searchToken = 0;
let collectionsCache = null;

function moneyFromShopify(price) {
  const n = Number(price);
  if (!Number.isFinite(n)) return "";
  const value = n > 9999 ? Math.round(n / 100) : n;
  return `Rs.${value.toLocaleString("en-PK")}`;
}

function searchRow(item) {
  return `<a class="search-row" href="${item.url}">
    <img src="${item.img}" alt="">
    <div><strong>${item.title}</strong><small>${item.price || item.type}</small></div>
    <em>${item.type}</em>
  </a>`;
}

function localSearch(q) {
  const query = q.toLowerCase();
  const items = products.filter((p) => p.title.toLowerCase().includes(query) || (p.desc || "").toLowerCase().includes(query) || (p.material || "").toLowerCase().includes(query)).map((p) => ({
    title: p.title,
    price: p.price,
    img: p.img,
    url: p.url || `/products/${encodeURIComponent(p.handle || p.id)}`,
    type: "Product"
  }));
  const cats = (collectionsCache || []).filter((c) => (c.title || "").toLowerCase().includes(query)).slice(0, 6).map((c) => ({
    title: c.title.replace(" Collection", ""),
    price: countLabel(c.count),
    img: shopImage(c.img),
    url: `/shop?collection=${encodeURIComponent(c.handle)}`,
    type: "Collection"
  }));
  return [...items, ...cats];
}

async function liveSearch(q) {
  const url = `/api/store/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8`;
  const data = await fetch(url).then((r) => r.json());
  const productsLive = (((data.resources || {}).results || {}).products || []).map((p) => {
    const handle = p.handle || String(p.url || "").split("/").filter(Boolean).pop() || "";
    return {
      title: p.title,
      price: moneyFromShopify(p.price),
      img: shopImage((p.image && p.image.url) || p.image || p.featured_image || ""),
      url: handle ? `/products/${encodeURIComponent(handle)}` : `/search?q=${encodeURIComponent(p.title)}`,
      type: "Product"
    };
  });
  const collectionsLive = (((data.resources || {}).results || {}).collections || []).map((c) => ({
    title: c.title,
    price: "",
    img: shopImage(c.featured_image || c.image || ""),
    url: `/shop?collection=${encodeURIComponent(c.handle || "")}`,
    type: "Collection"
  }));
  return [...productsLive, ...collectionsLive];
}

async function runSearch(q) {
  const token = ++searchToken;
  const query = q.trim();
  if (query.length < 2) {
    searchBox.innerHTML = "";
    return;
  }
  searchBox.innerHTML = `<p class="search-empty">Searching “${query}”...</p>`;
  if (!collectionsCache) {
    try { collectionsCache = await fetch("./collections.json").then((r) => r.json()); } catch (_) { collectionsCache = []; }
  }
  let items = [];
  try { items = await liveSearch(query); } catch (_) {}
  if (token !== searchToken) return;
  if (!items.length) items = localSearch(query);
  searchBox.innerHTML = items.length
    ? items.map(searchRow).join("")
    : `<p class="search-empty">No matches for “${query}”.</p>`;
}

function setSearchSuggest(idle) {
  const suggest = document.querySelector("[data-search-suggest]");
  const clearBtn = document.querySelector("[data-search-clear]");
  if (suggest) suggest.hidden = !idle;
  if (clearBtn) clearBtn.hidden = idle;
}

function openSearch() {
  closeMenu();
  searchRoot.hidden = false;
  setSearchSuggest(!(searchInput && searchInput.value.trim()));
  searchInput.focus();
  searchInput.select();
}

function closeSearch() {
  searchRoot.hidden = true;
  searchInput.value = "";
  searchBox.innerHTML = "";
  setSearchSuggest(true);
}

/* Header chrome already binds search on Shopify - avoid double handlers */
const openSearchBtn = document.querySelector("[data-open-search]");
const closeSearchBtn = document.querySelector("[data-close-search]");
if (openSearchBtn && searchRoot && searchInput && searchBox && !window.__manaSearchBound) {
  window.__manaSearchBound = true;
  openSearchBtn.addEventListener("click", openSearch);
  if (closeSearchBtn) closeSearchBtn.addEventListener("click", closeSearch);
  searchRoot.addEventListener("click", (e) => { if (e.target === searchRoot) closeSearch(); });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !searchRoot.hidden) closeSearch();
  });
  const clearBtn = document.querySelector("[data-search-clear]");
  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      searchInput.value = "";
      searchBox.innerHTML = "";
      setSearchSuggest(true);
      searchInput.focus();
    });
  }
  document.querySelectorAll("[data-search-chip]").forEach((chip) => {
    chip.addEventListener("click", () => {
      const q = chip.getAttribute("data-search-chip") || chip.textContent || "";
      searchInput.value = q;
      setSearchSuggest(false);
      runSearch(q);
      searchInput.focus();
    });
  });
  searchInput.addEventListener("input", () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    setSearchSuggest(!q);
    searchTimer = setTimeout(() => runSearch(searchInput.value), 220);
  });
}

const menuBtn = document.querySelector("[data-menu]");
const nav = document.querySelector("[data-nav]");
function closeMenu() {
  if (!nav || !menuBtn) return;
  nav.classList.remove("is-open");
  menuBtn.setAttribute("aria-expanded", "false");
}
if (menuBtn && nav) {
  menuBtn.addEventListener("click", () => {
    const open = nav.classList.toggle("is-open");
    menuBtn.setAttribute("aria-expanded", String(open));
  });
  nav.querySelectorAll("a").forEach((link) => link.addEventListener("click", closeMenu));
  window.addEventListener("resize", () => {
    if (window.innerWidth > 980) closeMenu();
  });
}

function initTrustSlider(root) {
  const track = root.querySelector("[data-trust-track]");
  const viewport = root.querySelector(".trust__viewport");
  if (!track || !viewport) return;
  const items = [...track.children];
  if (items.length < 2) return;

  const mq = window.matchMedia("(max-width: 640px)");
  let index = 0;
  let timer = null;
  let visible = true;
  let startX = 0;
  let dragging = false;

  function paint(instant) {
    if (!mq.matches) {
      track.style.transition = "none";
      track.style.transform = "";
      return;
    }
    const step = viewport.clientWidth;
    track.style.transition = instant ? "none" : "transform .55s cubic-bezier(.22,.61,.36,1)";
    track.style.transform = `translate3d(${-index * step}px,0,0)`;
  }

  function go(dir) {
    if (!mq.matches) return;
    index = (index + dir + items.length) % items.length;
    paint(false);
  }

  function play() {
    clearInterval(timer);
    timer = null;
    if (!mq.matches || !visible) return;
    timer = setInterval(() => go(1), Number(root.dataset.interval) || 3800);
  }

  function stop() {
    clearInterval(timer);
    timer = null;
  }

  paint(true);
  play();

  mq.addEventListener("change", () => {
    index = 0;
    paint(true);
    play();
  });
  window.addEventListener("resize", () => {
    if (!mq.matches) return;
    paint(true);
  });

  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      if (visible) play();
      else stop();
    }, { threshold: 0.25 });
    io.observe(root);
  }

  root.addEventListener("pointerdown", (e) => {
    if (!mq.matches || e.pointerType === "mouse" && e.button !== 0) return;
    dragging = true;
    startX = e.clientX;
    stop();
  });
  root.addEventListener("pointerup", (e) => {
    if (!dragging) return;
    dragging = false;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    play();
  });
  root.addEventListener("pointercancel", () => {
    dragging = false;
    play();
  });
  root.addEventListener("mouseenter", stop);
  root.addEventListener("mouseleave", play);
}

document.querySelectorAll("[data-trust-slider]").forEach(initTrustSlider);

/* Expose for mana-header.js sheet buttons */
window.renderWish = renderWish;
window.renderCart = renderCart;
window.renderCompare = renderCompare;
window.renderBook = renderBook;
window.paintCounts = paintCounts;

